import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  previewContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: 'fit-content',
    backgroundColor: theme.evPalette.charcoal[100],
    gap: '16px',
    padding: '24px',
    borderRadius: '4px',
    '@media (min-width: 1080px)': {
      height: '100%',
    },
  },
  previewSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '220px',
    '@media(min-width: 400px)': {
      width: '100%',
    },
  },
  previewHeadingText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    fontStyle: 'normal',
  },
  previewPaper: {
    transform: 'scale(0.8)',
    transformOrigin: 'top left',
    width: '269px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    minHeight: '350px',
    backgroundColor: theme.evPalette.salt[100],
    border: `1px solid ${theme.evPalette.charcoal[900]}`,
    maxWidth: '300px',
    '&.layout2': {
      display: 'flex',
      flexDirection: 'row-reverse',
      gap: '0px',
    },
    '&.layout3': {
      display: 'flex',
      flexDirection: 'row',
      gap: '0px',
    },
    '@media (min-width: 640px)': {
      transform: 'none',
    },
  },
  paperTitleBox: ({ primaryColor }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    gap: '6px',
    backgroundColor: primaryColor,
    borderBottom: `1px solid ${theme.evPalette.charcoal[900]}`,
    '&.layout2': {
      width: 'fit-content',
      flexDirection: 'reverse-row',
      padding: '10px 10px 0px 30px',
      borderBottom: '0px',
    },
    '&.layout3': {
      width: '7%',
    },
    '&.layout4': {
      backgroundColor: theme.evPalette.salt[100],
      padding: '30px 0px 0px 0px',
      borderBottom: '0px',
    },
    '&.layout5': {
      backgroundColor: theme.evPalette.salt[100],
      padding: '40px 0px 0px 0px',
      borderBottom: '0px',
    },
  }),
  paperHeadingText: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    textAlign: 'center',
    '&.layout1,&.layout2': {
      color: theme.evPalette.charcoal[200],
    },
    '&.layout2': {
      writingMode: 'vertical-lr',
      margin: '0px auto auto auto',
    },
    '&.layout4': {
      color: theme.evPalette.charcoal[900],
    },
    '&.layout5': {
      color: theme.evPalette.charcoal[900],
      margin: '0 40px 0 40px',
      textAlign: 'left',
    },
  },
  paperSubHeadingText: ({ primaryColor }) => ({
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '18px',
    margin: '0 auto 0 auto',
    '&.layout1': {
      color: theme.evPalette.charcoal[200],
    },
    '&.layout3': {
      display: 'none',
    },
    '&.layout4': {
      fontWeight: 600,
      fontSize: '5px',
      lineHeight: '11px',
      color: primaryColor,
    },
    '&.layout5': {
      fontWeight: 600,
      fontSize: '5px',
      lineHeight: '11px',
      margin: '0 0 0 40px',
      color: primaryColor,
      textAlign: 'left',
    },
  }),
  paperSubHeadingText2: ({ primaryColor }) => ({
    color: theme.evPalette.ocean[800],
    fontFamily: 'Noto Sans',
    fontWeight: 600,
    fontSize: '5px',
    lineHeight: '11px',
    textAlign: 'center',
    margin: '0px 20px 0px auto',
    '&.layout2': {
      margin: '0 auto 0 auto',
      color: primaryColor,
    },
    '&.layout3': {
      color: primaryColor,
    },
  }),
  paperContentBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '30px',
    width: '100%',
    '&.layout2': {
      paddingTop: '50px',
      gap: '25px',
    },
    '&.layout3': {
      paddingTop: '40px',
      gap: '15px',
    },
  },
  paperImage: {
    height: '125px',
    width: '122px',
    '&.layout1,&.layout2,&.layout4': {
      margin: '0 auto 0 auto',
    },
    '&.layout3': {
      margin: '0 auto 0 0',
    },
    '&.layout5': {
      margin: '0 0 0 40px',
    },
  },
  paperAddressTextContainer: {
    margin: '0 auto 0 auto',
    display: 'flex',
    flexDirection: 'column',
    '&.layout5': {
      margin: '0px auto 0px 0px',
    },
  },
  paperAddressText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 600,
    fontSize: '5px',
    lineHeight: '9px',
    margin: '0 auto 0 auto',
    '&.layout5': {
      margin: '0px auto 0px 0px',
    },
  },
  paperContentTextBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    width: 'fit-content',
    margin: '0px auto 0px auto',
    '&.layout2': {
      flexDirection: 'row',
      margin: '0 auto 0 auto',
      padding: '30px 0px 30px 0px',
    },
    '&.layout3': {
      flexDirection: 'row',
      margin: '30px auto 50px auto',
    },
    '&.layout4': {
      gap: '20px',
    },
    '&.layout5': {
      margin: '0px auto 0px 40px',
    },
  },
  paperContactText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '5px',
    lineHeight: '9px',
    margin: '0 auto 0 auto',
    '&.layout5': {
      margin: '0px auto 0px 0px',
    },
  },
  logo: {
    width: '75px',
    height: 'auto',
    margin: '0 auto 0 0',
    '&.layout4': {
      backgroundColor: theme.evPalette.salt[100],
      padding: '0px',
      margin: '20px auto 0px 0px',
    },
  },
  paperFooterBox: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    padding: '10px',
    width: '100%',
    backgroundColor: theme.evPalette.charcoal[400],
    '&.layout2': {
      backgroundColor: theme.evPalette.salt[100],
      padding: '0px 0px 5px 0px',
    },
    '&.layout3': {
      backgroundColor: theme.evPalette.salt[100],
      padding: '0px',
    },
    '&.layout4': {
      backgroundColor: theme.evPalette.salt[100],
      padding: '0px',
    },
    '&.layout5': {
      padding: '2px',
    },
  },
  paperFooterText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '5px',
    lineHeight: '18px',
    margin: '0 0 0 auto',
    '&.layout4': {
      margin: '20px 0 0 auto',
    },
  },
  downloadPrevieweBtn: {
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'fit-content',
    },
  },
}));
